import React from 'react';
import Section from './Section';

const Pricing = () => {
  const stripeLink = "https://buy.stripe.com/fZu8wRcqT9QBdDzb7S5os00";

  return (
    <Section id="pricing">
      <div className="max-w-lg mx-auto text-center">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-8">
          Early Access
        </h2>
        <div className="bg-white border-2 border-zinc-950 rounded-3xl p-8 md:p-12 shadow-xl shadow-zinc-900/5 relative">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-zinc-950 text-white px-4 py-1 rounded-full text-sm font-bold tracking-wide">
            LIMITED SPOTS
          </div>
          <div className="flex justify-center items-baseline gap-2 mb-4">
            <span className="text-6xl font-black tracking-tight text-zinc-900">$49</span>
            <span className="text-zinc-500 font-medium line-through decoration-2">$99</span>
          </div>
          <p className="text-zinc-600 mb-8 font-medium">
            Price will increase to $99 after the beta period ends.
          </p>
          <a 
            href={stripeLink}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full py-4 bg-zinc-950 text-white rounded-xl font-bold text-lg hover:bg-zinc-800 transition-all shadow-lg shadow-zinc-900/20 mb-6 active:scale-[0.98] text-center"
          >
            Get My Audit Now
          </a>
          <p className="text-sm text-zinc-500">
            One-time payment. Report delivered in 48 hours.
          </p>
        </div>
      </div>
    </Section>
  );
};

export default Pricing;